<template>
  <div class="app-product-slider-header flex flex-col items-center justify-start px-4 pt-6 pb-10">
    <h2 class="app-product-slider-header__title font-ds-small-h3 m-0">
      {{ item.title }}
    </h2>

    <div
      v-if="description"
      class="app-product-slider-header__description font-ds-large-body-lg mt-3 text-center"
      v-html="description"
    />

    <TappButton
      v-if="item.cta_text && item.cta_url"
      :to="item.cta_url"
      variant="primary"
      size="large"
      :text="item.cta_text"
      class="app-product-slider-header__cta mt-4"
      :data-analytics-url="item.cta_url"
      :data-analytics-link_text="item.cta_text"
    >
      {{ item.cta_text }}

      <BaseImage
        v-if="item.button_icon?.filename"
        :src="item.button_icon.filename"
        :alt="item.button_icon.alt || `${item.cta_text} icon`"
        :provider="getNuxtImageProviderFromSrc(item.button_icon.filename)"
        class="tapp-button__icon"
        :width="30"
        :height="30"
      />

      <TappIcon icon="arrow-right" class="tapp-button__icon" :size="16" />
    </TappButton>
  </div>
</template>

<script setup lang="ts">
  const { item } = defineProps<{
    item: MarketingProductSliderItemBlokStoryblok;
  }>();

  const description = computed(() => (item.description ? renderRichText(item.description) : ''));
</script>

<style lang="postcss" scoped>
  .app-product-slider-header {
    text-align: center;

    @media (--screen-lg) {
      flex: 1;

      &__cta {
        margin-top: auto;
      }
    }

    &__title,
    &__description {
      text-wrap: balance;
    }
  }
</style>
